import CookieOverlay from './CookieOverlay';

export default CookieOverlay;
